__turbopack_context__.v({
  "label": "pUILRW_label",
  "price": "pUILRW_price",
  "row": "pUILRW_row",
});
